import React, { useState, useEffect } from 'react';

const CurrencyRatesModal = ({ show, onClose, poundRate, dollarRate, euroRate, onSave, loading }) => {
  const [localPoundRate, setLocalPoundRate] = useState(poundRate || '');
  const [localDollarRate, setLocalDollarRate] = useState(dollarRate || '');
  const [localEuroRate, setLocalEuroRate] = useState(euroRate || '');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (show) {
      setLocalPoundRate(poundRate ?? '');
      setLocalDollarRate(dollarRate ?? '');
      setLocalEuroRate(euroRate ?? '');
      setMessage(null);
    }
  }, [show, poundRate, dollarRate, euroRate]);

  const handleSave = async () => {
    setMessage(null);
    try {
      await onSave(localPoundRate, localDollarRate, localEuroRate);
      setMessage({ type: 'success', text: 'Курси збережено!' });
      setTimeout(() => onClose(), 1000);
    } catch (err) {
      setMessage({ type: 'danger', text: err?.response?.data?.message || 'Помилка збереження' });
    }
  };

  if (!show) return null;
  return (
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
        onClick={() => !loading && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Курси валют</h5>
              <button type="button" className="close" aria-label="Close" onClick={() => !loading && onClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <div className="form-group">
                <label htmlFor="poundRate">Курс фунта (GBP → UAH)</label>
                <input
                  id="poundRate"
                  type="number"
                  className="form-control"
                  min="0"
                  step="0.01"
                  placeholder="Наприклад 58"
                  value={localPoundRate}
                  onChange={e => setLocalPoundRate(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="dollarRate">Курс долара (USD → UAH)</label>
                <input
                  id="dollarRate"
                  type="number"
                  className="form-control"
                  min="0"
                  step="0.01"
                  placeholder="Наприклад 42"
                  value={localDollarRate}
                  onChange={e => setLocalDollarRate(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="euroRate">Курс євро (EUR → UAH)</label>
                <input
                  id="euroRate"
                  type="number"
                  className="form-control"
                  min="0"
                  step="0.01"
                  placeholder="Наприклад 46"
                  value={localEuroRate}
                  onChange={e => setLocalEuroRate(e.target.value)}
                />
              </div>
              {message && (
                <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'} mt-3 mb-0`} role="alert">
                  {message.text}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => !loading && onClose()}>
                Закрити
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? 'Збереження…' : 'Зберегти'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrencyRatesModal;
